import SetupStep from "../SetupStep";

export default function ConnectStore() {
  return (
    <SetupStep
      title="Connect your store"
      description="Enable subscription functionality by connecting your Shopify store to Smartrr."
      id="connect-store"
      statusBadgeTestId="connect-store-status-badge"
      isStepCompleted={true}
    />
  );
}
